/**
 * Logs the customer out of the new site's own session (2026-10-30，阶段 6 ·
 * 身份搬家).
 *
 * 从前这里 POST 老站的 `/store/auth/better-auth/sign-out`（跨域、带
 * publishable key），只为了把老站身份域上的 BA cookie 一并杀掉，免得下一次
 * 走 authorize 又被「无感登回来」。现在会话就是本站的 cookie，一个同源
 * POST 就结束了 —— 不带 body 会被 better-auth 判成 400（实测），所以显式发
 * `{}`。
 *
 * 尽力而为：失败不阻碍、不延迟调用方自己的 `signout()` 服务端动作。
 */
export async function signOutBaSession(): Promise<void> {
  try {
    await fetch("/api/auth/sign-out", {
      method: "POST",
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({}),
    })
  } catch (error) {
    console.error(
      `[signOutBaSession] 新站登出失败，继续执行页面登出: ${String(error)}`
    )
  }
}
